import './style.css'
import ComfortItem from '../../../../entity/main-page/components/comfort-item'
import {useEffect, useRef, useState, useLayoutEffect} from 'react'
import {getConstruction, getObjects} from "../../../../shared/api/endpoints";
import Loader from "../../../../entity/main-page/components/loader";
import Skeleton from "../../../../entity/singel-card/components/skeleton";

interface ComfortItemData {
    title: string
    price: string
    metro: string
    image: string
    status: string,
    id: number,
    visible: boolean
}

const Comfort = () => {
    const comfortSectionRef = useRef<HTMLDivElement>(null);
    const btnRefMore = useRef<HTMLDivElement>(null);

    const [cards, setCards] = useState<ComfortItemData[]>([]);
    const [visibleCount, setVisibleCount] = useState(8);
    const [isLoading, setIsLoading] = useState(true);

    const fetchAllObjects = async () => {
        setIsLoading(true);
        let allCards: ComfortItemData[] = [];

        try {
            for (let page = 1; page <= 4; page++) {
                const { results } = await getConstruction(page);

                const newPlaces = results?.objects?.map(({ fields, image, ...other }: any) => {
                    let newItem = { ...other };
                    fields.forEach(({ source, value }: any) => (newItem[source] = value));
                    return { ...newItem, image: `https://novactive.homes${image}` };
                });

                allCards = [...allCards, ...newPlaces];
            }

            setCards(allCards);
        } catch (err) {
            console.error("Ошибка при загрузке объектов:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const waitForToken = (maxWaitTime = 5000, interval = 100): Promise<string> => {
        return new Promise((resolve, reject) => {
            const startTime = Date.now();
        
            const checkToken = () => {
            const token = localStorage.getItem('access');
            if (token) {
                resolve(token); 
                return;
            }
        
            if (Date.now() - startTime >= maxWaitTime) {
                reject(new Error('Token not found within the specified time')); 
                return;
            }
        
            setTimeout(checkToken, interval); 
            };
        
            checkToken();
        });
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                await waitForToken(); 
                setTimeout(() =>  fetchAllObjects(), 1000);      
            } catch (err) {
                console.error('Ошибка ожидания токена:', err);
            }
        };
        fetchData();
    }, []);

    const moreObjectsHandler = () => {
        const prevScrollY = window.scrollY;
        setVisibleCount((prev) => prev + 8);
        setTimeout(() => {
            window.scrollTo(0, prevScrollY); // Восстанавливаем скролл после обновления состояния
        }, 0.1);
    };

    return (
        <section className='comfort' id='comfort' ref={comfortSectionRef}>
            <div className='container'>
                <div className='comfort-body'>
                    <div className='comfort__header'>
                        <h2 className='comfort-title title'>
                            Комфортная жизнь
                            <span>в новой квартире </span>
                        </h2>
                    </div>
                    <div className='comfort-list'>
                        {!isLoading
                            ? cards.slice(0, visibleCount).map((item, index) => (
                                  <ComfortItem key={index} {...item} />
                              ))
                            : <Skeleton height={'250px'} />}
                    </div>
                    <div className="comfort__button-full" ref={btnRefMore}>
                        {visibleCount < cards.length ? (
                            <button type='button' onClick={moreObjectsHandler} disabled={isLoading}>
                                {isLoading ? <Loader /> : "показать ещё"}
                            </button>
                        ) : null}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Comfort;